import Link from "next/link";
import styled from "styled-components";
import { ButtonSizes, TextButton } from "../../styles/button";

export const ReasonCardContainer = styled.div`
  flex-basis: 100%;
  height: 100%;

  a,
  .inner-link-wrapper {
    flex-direction: column;
    width: 100%;
    height: 100%;
    text-decoration: none;
    padding: 34px;
    text-align: center;
    align-items: center;

    background-color: #fff;
    display: flex;
    border-radius: 16px;
    overflow: hidden;
    z-index: 0;
    position: relative;

    svg {
      margin-top: auto;
    }
  }
`;

export const ReasonCardHeadline = styled.span`
  font-size: 28px;
  line-height: 35px;
  font-weight: 700;
  width: 100%;
  word-break: break-word;
`;

export default function ReasonCard({
  title,
  image,
  buttonText,
}: {
  title: string;
  image: string;
  buttonText?: string;
}) {
  return (
    <ReasonCardContainer>
      <div className="inner-link-wrapper">
        <ReasonCardHeadline
          dangerouslySetInnerHTML={{ __html: title }}
        ></ReasonCardHeadline>
        <Link href="/register/talent/" passHref={true} aria-label={title}>
          <TextButton primary size={ButtonSizes.m}>
            {buttonText ? buttonText : "Weitere Infos"}
          </TextButton>
        </Link>

        {image}
      </div>
    </ReasonCardContainer>
  );
}
